"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Utils {
    static isFunction(value) {
        return typeof value === "function";
    }
    static isNumber(value) {
        return typeof value === "number";
    }
    static isInteger(value) {
        return typeof value === "number" && value % 1 === 0;
    }
    static isBoolean(value) {
        return value === true || value === false;
    }
    static isString(value) {
        return typeof value === "string";
    }
    static clone(v) {
        if (Utils.isObjectLiteral(v) || Array.isArray(v)) {
            return Utils.getDeepClone(v);
        }
        else {
            // Copy by value.
            return v;
        }
    }
    static cloneObjShallow(obj) {
        const keys = Object.keys(obj);
        const clone = {};
        for (const k of Object.keys(obj)) {
            clone[k] = obj[k];
        }
        return clone;
    }
    static merge(obj1, obj2) {
        for (const k of Object.keys(obj2)) {
            obj1[k] = obj2[k];
        }
        return obj1;
    }
    static isObject(value) {
        const type = typeof value;
        return !!value && (type === "object" || type === "function");
    }
    static isPlainObject(value) {
        const type = typeof value;
        return !!value && type === "object";
    }
    static isObjectLiteral(value) {
        return typeof value === "object" && value && value.constructor === Object;
    }
    static getArrayIndex(index, arr) {
        return Utils.getModuloIndex(index, arr.length);
    }
    static getModuloIndex(index, len) {
        if (len === 0)
            return index;
        while (index < 0) {
            index += Math.ceil(-index / len) * len;
        }
        index = index % len;
        return index;
    }
    static getDeepClone(obj) {
        if (Utils.isFunction(obj)) {
            // Copy functions by reference.
            return obj;
        }
        if (Array.isArray(obj)) {
            const c = [];
            for (const key of Object.keys(obj)) {
                const v = obj[key];
                c[key] = Utils.getDeepClone(v);
            }
            return c;
        }
        else if (Utils.isObject(obj)) {
            const c = {};
            for (const key of Object.keys(obj)) {
                const v = obj[key];
                c[key] = Utils.getDeepClone(v);
            }
            return c;
        }
        else {
            return obj;
        }
    }
    static equalValues(v1, v2) {
        if (typeof v1 !== typeof v2)
            return false;
        if (Utils.isObjectLiteral(v1)) {
            return Utils.isObjectLiteral(v2) && Utils.equalObjectLiterals(v1, v2);
        }
        else if (Array.isArray(v1)) {
            return Array.isArray(v2) && Utils.equalArrays(v1, v2);
        }
        else {
            return v1 === v2;
        }
    }
    static equalObjectLiterals(obj1, obj2) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        for (let i = 0, n = keys1.length; i < n; i++) {
            const k1 = keys1[i];
            const k2 = keys2[i];
            if (k1 !== k2) {
                return false;
            }
            const v1 = obj1[k1];
            const v2 = obj2[k2];
            if (!Utils.equalValues(v1, v2)) {
                return false;
            }
        }
        return true;
    }
    static equalArrays(v1, v2) {
        if (v1.length !== v2.length) {
            return false;
        }
        for (let i = 0, n = v1.length; i < n; i++) {
            if (!this.equalValues(v1[i], v2[i])) {
                return false;
            }
        }
        return true;
    }
    static setToArray(s) {
        const result = new Array();
        s.forEach((value) => {
            result.push(value);
        });
        return result;
    }
    static iteratorToArray(iterator) {
        const result = [];
        let iteratorResult = iterator.next();
        while (!iteratorResult.done) {
            result.push(iteratorResult.value);
            iteratorResult = iterator.next();
        }
        return result;
    }
    static isUcChar(charcode) {
        return charcode >= 65 && charcode <= 90;
    }
}
exports.Utils = Utils;
//# sourceMappingURL=Utils.js.map